import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useUserInfoContext } from "../../lib/contexts/UserInfoContext";
import { canReviewConversationResults, isUserAuthorized } from "@common/domain/auth";

export const ConversationResultsAuth = () => {
  const navigate = useNavigate();
  const { userInfo } = useUserInfoContext();

  useEffect(() => {
    if (userInfo) {
      if (!isUserAuthorized(userInfo.groups)) {
        navigate("/unauthorized");
      } else if (!canReviewConversationResults(userInfo.groups)) {
        navigate("/");
      }
    }
  }, [userInfo, navigate]);

  if (!userInfo || !canReviewConversationResults(userInfo.groups)) {
    return null;
  }

  return <Outlet />;
};

export default ConversationResultsAuth;
